/**
 * Created by ZhangJunPeng on 2017/5/24.
 */

import React from 'react';
import { TreeSelect } from 'antd';
import { customSelect } from '../commons/CustomSelect';

const CustomSelect = customSelect()(TreeSelect);
//
export default class MoreMeeting extends React.Component {
  render() {
    const {
      meetingTree,
      onMeetingChange,
      intl,
      selected,
      disabled,
      current,
      showType,
      showRooms = true,
      showCommon,
      treeDefaultExpandAll = false,
      selectRoomName = '',
      cmmaMeeting,
      searchPlaceholder = this.props.intl.formatMessage({
        id: 'report_placeholder_meeting_room'
      }),
      multiple = true,
      treeCheckable = true
    } = this.props;
    let treeData = [];
    if (
      showCommon &&
      meetingTree &&
      meetingTree.commons &&
      meetingTree.commons.length > 0
    ) {
      let commonOption = [];
      let commons = meetingTree.commons;
      commons.forEach(item => {
        // 选择视频会议时，常用会议室过滤普通会议室
        !(cmmaMeeting === 1 && item.capacity !== 6) &&
          commonOption.push({
            label: item.name,
            value: 'common-' + item.id.toString(),
            key: 'common-' + item.id,
            disabled: selected.indexOf(String(item.id)) > -1 ? true : false
          });
      });
      let commonRoot = {
        label: intl.formatMessage({id: 'room_name_comm'}),
        value: 'common-zone',
        key: '-001',
        children: commonOption
      };
      commonOption.length > 0 && treeData.push(commonRoot);
    }
    if (meetingTree && meetingTree.child) {
      if (meetingTree.child.length !== 0) {
        let areaArray = meetingTree.child;
        areaArray.forEach(item => {
          let everyOptions = [];
          if (item.child.length !== 0) {
            let secendOption = [];
            item.child.forEach(i => {
              let thrildOption = [];
              if (showRooms) {
                if (i.rooms.length !== 0) {
                  i.rooms.forEach(u => {
                    if (
                      current &&
                      current.toString().length > 0 &&
                      current.toString().indexOf(u.id.toString()) >= 0
                    ) {
                    } else {
                      thrildOption.push({
                        label: intl.locale === 'en_US'?u.nameEn:u.name,
                        value: u.id.toString(),
                        key: `${item.id}-${i.id}-${u.id}`,
                        disabled:
                          showCommon && selected.indexOf('common-' + u.id) > -1
                            ? true
                            : false
                      });
                    }
                  });
                }
                if (thrildOption.length > 0) {
                  secendOption.push({
                    label: i.name,
                    value: i.id.toString() + 'building',
                    key: `${item.id}-${i.id}`,
                    children: thrildOption
                  });
                }
              } else {
                secendOption.push({
                  label: i.name,
                  value: i.id.toString(),
                  key: `${item.id}-${i.id}`,
                  children: thrildOption
                });
              }
            });
            if (secendOption.length > 0) {
              everyOptions = {
                label: item.name,
                value: item.id.toString() + 'zone',
                key: `${item.id}`,
                children: secendOption
              };
              treeData.push(everyOptions);
            }
          }
        });
      }
    }
    const tProps = {
      treeData,
      value: selected,
      onChange: onMeetingChange,
      multiple: multiple,
      treeCheckable: treeCheckable,
      disabled: disabled,
      searchPlaceholder: searchPlaceholder,
      dropdownStyle: { maxHeight: 520 },
      treeDefaultExpandAll: treeDefaultExpandAll,
      treeNodeFilterProp: "title"
    };

    return showType ? <TreeSelect {...tProps} /> : <CustomSelect {...tProps} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/meeting/MoreMeeting.js